/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import AbstractKafkaCodeSnippet from './AbstractKafkaCodeSnippet';
import { generateFileName } from 'utils/common';

export default class KafkaJSKafkaCodeSnippet extends AbstractKafkaCodeSnippet {
  getBootstrapServers() {
    return this.apiHandler
      .getEndpoints()
      .map(({ url }) => `'${url}'`)
      .join(', ');
  }

  getSchemaInformation() {
    const { type: schemaType } = this.apiHandler.getFirstSchema(this.channelName);

    const isAvro = this.apiHandler.isAvroSchema(schemaType);

    return {
      isAvro,
      fileName: generateFileName(this.channelName, isAvro ? 'avsc' : 'json')
    };
  }

  getKeyDeserializer() {
    return '';
  }

  sasl_ssl() {
    return {
      SASL: true,
      SSL: true,
      saslMechanism: 'plain'
    };
  }

  sasl_plain() {
    return {
      SASL: true,
      saslMechanism: 'plain'
    };
  }

  ssl() {
    return {
      SSL: true
    };
  }

  ssl_mutualtls() {
    return {
      MUTUAL_TLS: true
    };
  }

  plaintext() {
    return {};
  }

  sasl_sha_256() {
    return {
      SASL: true,
      saslMechanism: 'scram-sha-256'
    };
  }

  sasl_sha_512() {
    return {
      SASL: true,
      saslMechanism: 'scram-sha-512'
    };
  }

  sasl_ssl_sha_256() {
    return {
      SASL: true,
      SSL: true,
      saslMechanism: 'scram-sha-256'
    };
  }

  sasl_ssl_sha_512() {
    return {
      SASL: true,
      SSL: true,
      saslMechanism: 'scram-sha-512'
    };
  }
}
